import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { NdtLogoComponent } from './ndt-logo.component';

@NgModule({
   declarations: [NdtLogoComponent],
   exports: [NdtLogoComponent],
   imports: [CommonModule],
})
export class NdtLogoModule {}
